import React from 'react';

const AddressDisplay = ({ addressRef, text }) => (
  <div
    ref={addressRef}
    className="address-display"
  >
    {text}
  </div>
);

export default AddressDisplay;